import { Draggable } from "react-beautiful-dnd";
import { TournamentEvent } from "../../../types/types";
import { formatTime } from "../../../utils";
import KebabMenu from "../../../components/kebabmenu";
import { useMemo } from "react";

interface Props {
    event: TournamentEvent;
    index: number;
    onDelete: (eventId: string, locationId: string) => void;
    onEdit?: (event: TournamentEvent) => void;
    isEditing: boolean;
}

const AdminTournamentEvent = (props: Props) => {
    const { index, event, onDelete, onEdit, isEditing } = props;

    const kebabMenu = useMemo(() => {
        return [
            { label: "Rediger", onClick: () => onEdit?.(event) },
            { label: "Slet", onClick: () => onDelete(event.id, event.location.id) }
        ];
    }, [event, onDelete, onEdit]);

    return (
        <Draggable key={event.id} draggableId={event.id} index={index}>
            {(provided) => (
                <div
                    style={{ position: "relative" }}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                >
                    <div
                        style={{
                            border: "1px solid #aaffaa",
                            boxShadow: "rgba(0, 0, 0, 0.04) 0px 5px 22px, rgba(0, 0, 0, 0.03) 0px 0px 0px 0.5px",
                        }}
                        className="admin-match"
                    >
                        <div className="top-container">
                            Tournament Event
                        </div>
                        <div className="center-container">
                            <div className="column1">
                                {formatTime(event.startTime)}
                            </div>
                            <div className="column2">
                                <div className="tournament-event-title" style={{ padding: "10px" }}>
                                    {event.title}
                                </div>
                            </div>
                            <KebabMenu items={kebabMenu} />
                        </div>
                    </div>
                </div>
            )}
        </Draggable>
    );
};

export default AdminTournamentEvent;
